// extracted by mini-css-extract-plugin
export default {"search_result":"addOrderOnlineAdmin_search_result__AUXNA"};